import script from "./TerminateWorkDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TerminateWorkDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TerminateWorkDialog.vue?vue&type=style&index=0&id=5f40c592&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f40c592"]])

export default __exports__